export const ROUTES = {
  HOME: "/",
  PROJECT: "/project",
  NOT_FOUND: "/404",
} as const;

export enum Pages {
  index = "index",
  project = "project",
  notFound = "notFound",
}
